import { Injectable } from '@angular/core'

import { Localization } from '@aa-app-localization'

import { ProductSearchGatewayService } from '@app-domains/meilisearch/services/product-search-gateway.service'
import {
    ProductSearchHit,
    ProductSearchInput,
    ProductSearchResult,
} from '@app-domains/meilisearch/types/product-search.types'

@Injectable({ providedIn: 'root' })
export class ProductSearchService {

    constructor(
        private readonly gateway: ProductSearchGatewayService,
    ) {
    }

    public execute(input: ProductSearchInput): Promise<ProductSearchResult> {
        return this.gateway.search(input)
    }

    public getRecommendations(
        ean: string,
        locale: Localization.Locale,
        limit: number,
    ): Promise<ProductSearchHit[]> {
        return this.gateway.recommendations(ean, locale, limit)
    }

}
